module.exports = __webpack_public_path__ + "media/dashboard/assets/images/assistents/lead_qualification-3e7fe6fda9f3ee9195137ea0dcfa36f9.png";